import { IState } from 'shared/store';

export const transportAccessibilityRateSelector = (state: IState): string | undefined => {
  const rate = state.offerData.newObject?.transportAccessibilityRate;

  return rate ? String(rate).replace('.', ',') : undefined;
};
